import styles from "./posts.module.scss";
import Image from 'next/image'
import { useRouter } from "next/router";
import Layout from "@/components/layout";
import Head from "next/head";
import { getLangLink } from "@/utils/lang";
import Banner1 from './banner'
import fb2 from "@images/report/facebook.png";
import linkin2 from "@images/report/instagram.png";
import tw2 from "@images/report/twitter.png";
import LoginFree from './loginFree'
type Props = {
    [propsName: string]: any
}
type postType = {
    post: any;
    t: any
    previousPost: any;
    nextPost: any;
    detailList: any[];
    readMores: any[];
  };
const Index = (props: Props) => {
    const { t, width } = props
    const router = useRouter();
    const { locales, locale: activeLocale } = router;
    const { post, previousPost, nextPost, readMores, detailList }: postType = props.dataDetail;
    const handleHref = (e, name) => {
      let height = $(`h2[id=${name}]`).offset().top;
      let top = $(`h2[id=${name}]`).height() + 30
      setTimeout(()=> {
        document.documentElement.scrollTop = height - top

      })
    }
  return (
    <Layout header={true} footer={true} >
    <div className={styles.post + " "}>
      <Head>
        <title>
          {post?.seoTitle || "TikTok Online Analytics Tool | TikMeta Insight"}
        </title>
        <meta
          name="keywords"
          content={
            post?.seoTitle ||
            "tiktok online analytics tool, tiktok user analytics, tiktok account analytics,tiktok influencer analytics,tiktok video downloader,download without watermark, how to see tiktok analytics"
          }
        />
        <meta
          name="description"
          content={post?.seoDesc || "tiktok online analytics tool"}
        />
      </Head>
      <div className=" overflowHidden relative h-full">
        <div className={styles.banner}>
        <Banner1></Banner1>
        </div>
      <div>
      <div className={styles.container + " defeaultContainer"}>


        <div className={styles.share_wrap}>
          <a
            target={"_blank"}
            href={`http://www.linkedin.com/shareArticle?mini=true&ro=true&title=${
              post?.title
            }&url=${
              process.env.NEXT_PUBLIC_PORTAL_URL + "posts/" + post?.seoUrl
            }&armin=armin`}
            className="mr-[16px]"
            rel="noreferrer"
          >
            <Image width={24} height={24} src={linkin2} alt=""></Image>
          </a>
          <a
            target={"_blank"}
            href={`https://www.facebook.com/sharer/sharer.php?u=${
              process.env.NEXT_PUBLIC_PORTAL_URL + "/posts/" + post?.seoUrl
            }`}
            className="mr-[16px]"
            rel="noreferrer"
          >
            <Image width={24} height={24} src={fb2} alt=""></Image>
          </a>
          <a
            target={"_blank"}
            href={`https://twitter.com/intent/tweet?text=${post?.title}&url=${
              process.env.NEXT_PUBLIC_PORTAL_URL + "/posts/" + post?.seoUrl
            }`}
            rel="noreferrer"
          >
            <Image width={24} height={24} src={tw2} alt=""></Image>
          </a>
        </div>
        <div className={`${styles.details} lg1024:pt-[20px] text-[#708096]`}>
          <a
            href={
              process.env.NEXT_PUBLIC_PORTAL_URL +
              getLangLink("", activeLocale)
            }
            className="!text-[#708096] hover:!text-[#ff3e5f]"
          >
            {t("Home")}
          </a>
          <span> / </span>
          <a href={getLangLink("/posts", activeLocale)} className="hover:!text-[#ff3e5f]">
            {t("Posts", 'nav')}
          </a>
          <span> / </span>
          <a href={getLangLink(`/posts/category/${post?.categorySeoUrl}`, activeLocale)}
             className="hover:!text-[#ff3e5f]"
          >
            {post?.categoryName2}
          </a>
          <span> / </span>
          <span style={{color: '#2e384e'}}>{t("details")}</span>
        </div>
        <div className={`bg-[#fff]  mt-[20px] rounded-[8px] lg1024:p-0 ${styles['art-box']}`}>
          {/*{readMores && readMores.length ? <div className={styles.moreBox}>*/}
          {/*  <a href="/posts" className="font-bold" style={{fontFamily: 'Poppins'}}>{t('readmore', 'blog')} → </a>*/}
          {/*  {readMores.map((item, key) => <a key={key} href={`/posts/${item.seoUrl}`}>{item.title}</a>)}*/}

          {/*</div> : ''}*/}
          {detailList && detailList?.length ? <div className={`${styles['h2-link-box']} sticky top-[60px] pt-[40px]`}>
          <h3 className={styles.linkTitle}>{t('tableOfContent', 'home')}</h3>
          <ul className={styles.ulList}>
            {detailList && detailList.map((item, index) => (<li key={index}><a href={`#${'articleTitle' + (index + 1)}`} onClick={(e) => handleHref(e, 'articleTitle' + (index + 1))} dangerouslySetInnerHTML={{__html: item}}></a></li>))}
          </ul>
        </div> : ''}

        <div className={`${styles['h2-box-content']} ${detailList && detailList?.length ? '': ' ml-[300px] lg1024:ml-[0px] flex-1' }`}>

          <div
            className={
              styles.title + " max-w-[780Px] mb-[24px] lg1024:!text-[18px] lg1024:!leading-[28px] pt-[40px]"
            }
          >
            {post?.title}
          </div>

          <div className="mb-[16px] lg1024:text-[12px]">
            { post.author ? <span className="mr-[12px]">{post.author}</span> : null }
            <span>{post.createTime}</span>
          </div>

          <div
            style={{ maxWidth: "780Px" }}
            dangerouslySetInnerHTML={{
              __html: post?.content,
            }}
            className={styles.works}
          />



        </div>
        <LoginFree></LoginFree>
        </div>
        {/*<div className={styles.preNext} style={{ width: "100%" }}>*/}
        {/*      {previousPost ? (*/}
        {/*        <a*/}
        {/*          href={getLangLink(*/}
        {/*            `/posts/${previousPost?.seoUrl}`,*/}
        {/*            activeLocale*/}
        {/*          )}*/}
        {/*          title={previousPost?.title}*/}
        {/*        >*/}
        {/*          <div className={styles.Pre}>*/}
        {/*            <div*/}
        {/*              className={styles.pre}*/}
        {/*              style={{ justifyContent: "flex-end" }}*/}
        {/*            >*/}
        {/*              <div className={styles.pn + " lg1024:!text-[14px]"}>*/}
        {/*                {t("pre")}*/}
        {/*              </div>*/}
        {/*              <div className={styles.arrow + " lg1024:!text-[12px]"}>*/}
        {/*              ←*/}
        {/*              </div>*/}
        {/*            </div>*/}
        {/*            <div className={`${styles.pnTitle} ${styles.textRight}`}>*/}
        {/*              <a>*/}
        {/*                <span*/}
        {/*                  style={{ display: "block" }}*/}
        {/*                  className="lg1024:!hidden"*/}
        {/*                >*/}
        {/*                  {previousPost.title}*/}
        {/*                </span>*/}
        {/*              </a>*/}
        {/*            </div>*/}
        {/*          </div>*/}
        {/*        </a>*/}
        {/*      ) : <div style={{flex: '0 0 200px'}}></div>}*/}
        {/*      {nextPost ? (*/}
        {/*        <a*/}
        {/*          href={getLangLink(`/posts/${nextPost?.seoUrl}`, activeLocale)}*/}
        {/*          title={nextPost?.title}*/}
        {/*        >*/}
        {/*          <div className={styles.Pre}>*/}
        {/*            <div className={styles.pre}>*/}
        {/*              <div*/}
        {/*                className={styles.arrow + " lg1024:!text-[12px]"}*/}
        {/*                style={{ marginLeft: "0" }}*/}
        {/*              >*/}
        {/*                →*/}
        {/*              </div>*/}
        {/*              <div className={styles.pn + " lg1024:!text-[14px]"}>*/}
        {/*                {t("next")}*/}
        {/*              </div>*/}
        {/*            </div>*/}
        {/*            <div className={styles.pnTitle}>*/}
        {/*              <a*/}
        {/*                title={nextPost?.seoTitle}*/}
        {/*                style={{ display: "block" }}*/}
        {/*                className="lg1024:!hidden"*/}
        {/*              >*/}
        {/*                {nextPost.title}*/}
        {/*              </a>*/}
        {/*            </div>*/}
        {/*          </div>*/}
        {/*        </a>*/}
        {/*      ) : (*/}
        {/*        <div style={{flex: '0 0 200px'}}></div>*/}
        {/*      )}*/}
        {/*  </div>*/}
        {/* <hr className={styles.hr} /> */}
        {
          post.author ? <div className="flex lg1024:block items-center mt-[48px] p-[30px] bg-[#F7F8FA] rounded-[8px] mt-[65px] lg1024:p-[20px]"
            style={{background: '#F7F8FA'}}>
            <div className="mr-[16px] min-w-[80px] min-h-[80px]">
              <Image src={post.authorPic} width={80} height={80} />
            </div>
            <div>
              <p className="text-[16px] text-[#0A122C] mb-[14px] lg1024:mb-0 lg1024:ml-[20px]">{post.author}</p>
              <p className="my-0 text-[16px] leading-[18px] !text-[#191919] lg1024:mt-[16px] lg1024:text-[12px] lg1024:leading-[14px]">{post.authorDesc}</p>
            </div>
          </div>
            : null
        }
        {/* 相关文章 */}
        <div className={styles.moreBox}>
          <div className={`text-[48px] text-center color-[#000] leading-[48px] lg1024:text-[28px] font-bold ${styles.moreBox_title}`}>{t('readmore', 'blog')}</div>
          <div className="flex flex-wrap gap-[24px] mt-[65px] lg1024:mt-[32px] justify-between">
            {
              readMores.map((item, key) => {
                return <a href={`/posts/${item.seoUrl}`} key={key} className="w-[30%] lg1024:w-full cursor-pointer flex flex-col gap-[16px] lg1024:gap-[8px]">
                  <div className={`text-[#000] text-[20px] lg1024:text-[18px] cursor-pointer font-bold ${styles.moreBox_subTitle}`}>{item.title}</div>
                  <div className="text-[#484848] cursor-pointer lg1024:text-[15px]">{item.desc}</div>
                  <div className="text-[#484848] lg1024:text-[14px]">
                    { item.author ? <span className="mr-[12px]">{item.author}</span> : null }
                    <span>{item.updateTime}</span>
                  </div>
                </a>
              })
            }
          </div>
        </div>
      </div>
  </div></div>
    </div>
  </Layout>
  )
}
export default Index
